import { Navigate } from 'react-router-dom';
import { useAuth, homePathFor } from '../context/AuthContext';

function ProtectedRoute({ children, requiredRole }) {
  const { currentUser } = useAuth();

  if (!currentUser) return <Navigate to="/login" replace />;

  if (requiredRole && currentUser.role !== requiredRole) {
    return <Navigate to={homePathFor(currentUser.role, '/rooms')} replace />;
  }

  return children;
}

export default ProtectedRoute;
